import React, { Component } from "react";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { CheckBox } from "../../../../../common/custom-form/checkbox.component";
import { AUDIT_MODAL_TITLE, AUDIT_RULES } from "../../../../../../constants/external-constants";
import { invoiceAuditRulesActions } from "../../../../../../store/external/invoice/invoice/audit-table.reducer";

class AuditModal extends Component {
    constructor(props) {
        super(props);     

        this.state = {
            selectedRules: this.props.selectedRules
        };
    }

    componentDidMount() {
        this.handleCheckboxChange(AUDIT_MODAL_TITLE.CircuitNotFound)
    }

    componentWillUnmount() {
        const { invoiceDetailsId, getAuditChartData } = this.props
        getAuditChartData(invoiceDetailsId);
    }

    handleCheckboxChange = (ruleName) => {
        this.setState(prevState => {
            let newSelectedRules = { ...prevState.selectedRules };
    
            if (ruleName === "Select All") {              
                const isSelectAllChecked = !newSelectedRules["Select All"].checked;               
                AUDIT_RULES.forEach(rule => {
                    if (!rule.disabled) {
                        newSelectedRules[rule.value].checked = isSelectAllChecked;                       
                    }
                });
            } else {      
                if(ruleName !== AUDIT_MODAL_TITLE.CircuitNotFound)   
                {
                    newSelectedRules[ruleName].checked = !newSelectedRules[ruleName].checked;  
                }  
                const isAllChecked = AUDIT_RULES.every(rule => 
                    newSelectedRules[rule.value].checked || rule.value === AUDIT_MODAL_TITLE.CircuitNotFound
                );    
               
                newSelectedRules["Select All"].checked = isAllChecked;
            }    
           
            const formattedSelectedRules = Object.entries(newSelectedRules)
                .filter(([value, rule]) => rule.checked && value !== "Select All")
                .map(([value, rule]) => ({ id: rule.id, key: rule.key, value: value }));    
           
            this.props.onSelectedRules(formattedSelectedRules);
    
            return { selectedRules: newSelectedRules };
        });
    };
    

    render() {
        return (
            <>
                <h1>{AUDIT_MODAL_TITLE.AuditRules}</h1>
                <div className="details-container">
                    <CheckBox
                        label="Select All"
                        checked={this.state.selectedRules["Select All"].checked}
                        classWrapper="audit-rule__data audit-rule__select-all"
                        handleOnChange={() => this.handleCheckboxChange("Select All")}
                    />
                    <div className="audit-rule__list">
                        {AUDIT_RULES.filter(rule => rule.value !== "Select All").map((rule, index) => (
                            <div className="checkbox-audit-container" key={index}>
                                <CheckBox
                                    label={rule.value}
                                    disabled={rule.disabled}
                                    checked={this.state.selectedRules[rule.value].checked}
                                    classWrapper="audit-rule__data"
                                    handleOnChange={() => this.handleCheckboxChange(rule.value)}
                                />
                                <div className="checkbox-audit-container__hover">
                                    <span>{rule.tooltip}</span>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </>
        );
    }
}

export default connect(
    state => {
        const { invoiceAuditRules } = state;

        return {
            invoiceAuditRules
        };
    },
    dispatch => bindActionCreators(
        Object.assign({}, invoiceAuditRulesActions),
        dispatch
    )
)(AuditModal);
